import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router';
import { LOCALE_LIST, setLocale } from '@triplabo/web/i18n';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { locale } = useParams();

  useEffect(() => {
    if (locale && LOCALE_LIST.includes(locale)) {
      setLocale(locale);
    }
  }, [locale]);

  return (
    <div className={styles.base}>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default BaseLayout;
